import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { StoreService } from 'src/app/services/store.service';
import { ResponsiveLayoutService } from 'src/app/services/responsive-layout.service';
import { ExcelService } from 'src/app/services/excel.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastService } from 'src/app/services/toast.service';
import { AdminTableComponent, ButtonClass } from 'src/app/shared/admin-table/admin-table.component';
import { PlantAdmin } from 'src/app/models/plant';
import { CotizacionService } from 'src/app/services/cotizacion.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalAlertComponent } from 'src/app/shared/modal-alert/modal-alert.component';
import { formatNumber } from '@angular/common';
import Swal from 'sweetalert2';
import { SwalAlertService } from 'src/app/services/swal-alert.service';


@Component({
  selector: 'app-cotizacion',
  templateUrl: './cotizacion.component.html',
  styleUrls: ['./cotizacion.component.css']
})
export class CotizacionComponent implements OnInit {
  @ViewChild('table') table!: AdminTableComponent<PlantAdmin>;
  swal = inject(SwalAlertService);

  data$!: string;
  mapHeader = {
    payment_method: { display: 'Método', data: null },
    order_buy: { display: 'Orden Compra', data: null },

    razon_social: { display: 'Nombre', data: null },
    email: { display: 'Mail', data: null },
    rut: { display: 'RUT', data: null },
    giro: { display: 'Giro', data: null },
    address_payment: { display: 'Dirección', data: null },
    phone: { display: 'Teléfono', data: null },

    product: { display: 'Producto', data: null },
    product_sap: { display: 'Código SAP', data: null },
    plant: { display: 'Planta', data: null },

    total_price: { display: 'Precio Total', data: null },
    request_amount: { display: 'Cantidad', data: null },
    address_dispatch: { display: 'Dirección Despacho', data: null },
    address_latitud: { display: 'Latitud', data: null },
    address_longitud: { display: 'Longitud', data: null },

    schedule: { display: 'Fecha', data: null },
    hours: { display: 'Rango Horario', data: null },

    state: { display: 'Estado', data: null },
    created_at: { display: 'Solicitado', data: null },
    date_buy: { display: 'Día de Pago', data: null },

    authorization_code: { display: 'Código de Autorización', data: null },
    payment_type: { display: 'Tipo de Pago', data: null },
    ejecutivo_email: { display: 'Ejecutivo', data: null },

    address_complementary_dispatch: { display: 'Dirección Complementaria', data: null },
    address_complementary_latitud: { display: 'Latitud Complementaria', data: null },
    address_complementary_longitud: { display: 'Longitud Complementaria', data: null },
    sujeta_factibilidad: { display: 'Sujeta a Factibilidad', data: null },

    actions: {
      display: 'Acciones',
      sort: false,
      data: (data: any) => {
        return `
        <div>
<button class="btn btn-link btn-action" title="Cambiar estado a cerrado" data-bs-toggle="tooltip" data-action="changeStatus" title="Cambiar estado" ${data.state == "Pendiente" ? "" : "disabled"}>
                <svg class="bi" width="20" height="20" fill="currentColor">
                  <use xlink:href="assets/img/bootstrap-icons.svg#check2-all" />
                </svg>
              </button>
        
              <button class="btn btn-link btn-action" title="Variables Utilizadas" data-bs-toggle="tooltip" data-action="seeVariables" title="Revisar Variables"">
                <svg class="bi" width="20" height="20" fill="currentColor">
                  <use xlink:href="assets/img/bootstrap-icons.svg#eye" />
                </svg>
              </button>
        
              

        <div>
              
              `;
      },
      changeStatus: (data: any) => { this.changeClosedStatus(data); },
      seeVariables: (data: any) => { this.onseeValues(data); }
    },
  };
  botones: ButtonClass[] = [

    {
      texto: 'Generar PDF Cotización',
      css: 'btn-success',
      accion: () => this.consultarCotizacion()
    }
  ];
  constructor(
    private readonly storeService: StoreService,
    public responsiveService: ResponsiveLayoutService,
    private readonly excelService: ExcelService,
    private readonly spinner: NgxSpinnerService,
    private readonly toastService: ToastService,
    private readonly cotizacionService: CotizacionService,
    private readonly modalService: NgbModal,
  ) {
  }

  ngOnInit(): void {
    this.data$ = 'cotizacion/';
  }

  changeStatus(ele: any) {
    this.spinner.show();
    this.cotizacionService.changeStateCotizacion({ order_buy: ele.order_buy }).subscribe({
      next: () => {
        this.toastService.showAdminSuccess('El estado ha sido cambiado a Cerrado.');
        this.spinner.hide();
        this.table.reload();
      },
      error: () => {
        this.toastService.showAdminError('Ocurrio un error al intentar cambiar el estado a cerrado', { delay: 3000 });
        this.spinner.hide();
      }
    });
  }

  changeClosedStatus(ele: any) {
    const modalRef = this.modalService.open(ModalAlertComponent, { centered: true });
    modalRef.componentInstance.title = '¿Desea continuar?';
    modalRef.componentInstance.accion = 'Sí, cambiar';
    modalRef.componentInstance.description = 'Se cambiará el estado de la cotización a cerrado.';
    modalRef.componentInstance.function = () => {
      this.modalService.dismissAll();
      this.changeStatus(ele);
    };
  }
  /**
   * Funcion para revisar los valores utilizado en los calculos
   * @param ele 
   */
  onseeValues(ele: any) {
    console.log(ele);
    const modalRef = this.modalService.open(ModalAlertComponent, { centered: true });
    modalRef.componentInstance.title = `Valores Pedido ${ele.order_buy}`;
    modalRef.componentInstance.accion = 'Ok';
    let mensaje = ''
    mensaje += `<br><strong>Planta</strong>: ${ele.plant}`
    mensaje += `<br><strong>Cantidad</strong>: ${ele.request_amount} m<sup>3</sup>`
    mensaje += `<br><strong>Día</strong>: ${ele.dia}`
    mensaje += `<br><strong>Sección</strong>: ${ele.seccion}`
    mensaje += `<br><strong>Horario</strong>: ${ele.hours}`

    mensaje += `<br><strong>UF</strong>: ${this.convertValue(ele.uf, '1.0')} CLP`
    mensaje += `<br><strong>Precio Unitario  </strong>: ${this.convertValue(ele.producto_unitario, '1.0')} UF`
    mensaje += `<br><strong>Precio Carga Incompleta</strong>: ${this.convertValue(ele.carga_incompleta)} UF`
    mensaje += `<br><strong>Precio Ajuste Horario</strong>: ${this.convertValue(ele.factor_price, '1.0')} UF`
    modalRef.componentInstance.descriptionHTML = mensaje;
    modalRef.componentInstance.function = () => {
      this.modalService.dismissAll();
    };
  }

  /**
   * Devuelve string formateado desde un nunmero
   * @param numero 
   * @param formato 
   * @returns 
   */
  convertValue(numero: any, formato: string = '1.1') {
    try {
      return formatNumber(numero, 'es-CL', formato);
    } catch (ex) {
      return ''
    }
  }

  async consultarCotizacion(valor = '') {
    const cotizacion = await this.swal.showTextInputSwal('Número de Cotización', 'OD9999999999', 'Buscar', valor);
    if (cotizacion) {
        this.toastService.showAdminAttention('Por favor, espere unos segundos mientras preparamos el archivo.', { delay: 3000 });

      this.generarPdf(cotizacion);
    }
  }
  /******SECCION GENERAR PDF***** */
  /**
   * Funcion encargada de descargar los pdf de la cotizacion
   * @param ele 
   */
  generarPdf(ele: any) {
    this.storeService.generatePdf(ele).subscribe({
      next: (response: Blob) => {
        // this.toastService.show('', 'Generando Documento', { classname: 'bg-danger text-light toast-top-right', delay: 3000 });
        this.toastService.showAdminSuccess('Se ha generado correctamente el documento.');
        const blob = new Blob([response], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const documentName = `Cotizacion_${ele}.pdf`

        const a = document.createElement('a');
        a.href = url;
        a.download = documentName;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        this.spinner.hide();
      },
      error: async (error: any) => {
        let mensajeDefault = 'Ocurrio un error al intentar descargar el documento'
        if (error.error instanceof Blob && error.error.type === 'application/json') {
          error.error.text().then((text: string) => {
            const data = JSON.parse(text);
            const mensaje = data.msg || 'Ocurrió un error inesperado';
            this.swal.mostrarNotificacion('Atención', mensaje, 'Ok', 'warning');
          });
        }
        const posibleBlob = error.error;
        if (posibleBlob && typeof posibleBlob.text === 'function') {
          posibleBlob.text().then((text: string) => {
            try {
              const data = JSON.parse(text);
              console.log(`Json ${data}`)
              mensajeDefault = data.msg || mensajeDefault;
            } catch (e) {
              mensajeDefault = mensajeDefault;
            }
          });
        }

        const valor = await this.swal.mostrarNotificacion('Atención', mensajeDefault, 'Ok', 'warning');
        if (valor) {
          this.consultarCotizacion(ele);
        }
        // this.toastService.show('error', 'Ocurrio un error al intentar descargar el documento', { classname: 'bg-danger text-light toast-top-right', delay: 3000 });
        this.spinner.hide();
      }
    })
  }

}
